import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getAll(data) {
        let params = "";
        if (data) {
            Object.keys(data).forEach(key => {
                params += `${key}=${data[key]}&`;
            });
        }
        return api.get(`/api/v1/subcategory?${params}`);
    },
    getAllList(params) {
        return api.post(`/api/v1/subcategory/list?is_product=${params}`);
    },
    getById(id) {
        return api.get(`/api/v1/subcategory/${id}`);
    },
    update(id, data) {
        return api.post(`/api/v1/subcategory/${id}`, data);
    },
    create(data) {
        return api.post(`/api/v1/subcategory`, data);
    },
    delete(id) {
        return api.delete(`/api/v1/subcategory/${id}`);
    },
}